import { Order } from "models/Order";
import { createContext, useContext } from "react";

type OrderContextProps = {
  children: React.ReactNode;
  order: Order;
};

const OrderContext = createContext<Order | undefined>(undefined);

const useOrderContext = () => {
  const context = useContext(OrderContext);
  if (!context) {
    throw new Error("useOrderContext must be used within an OrderProvider");
  }
  return context;
};

const OrderProvider: React.FC<OrderContextProps> = ({ children, order }) => {
  return <OrderContext.Provider value={order}>{children}</OrderContext.Provider>;
};

export { OrderProvider as default, useOrderContext };
